// extracted by mini-css-extract-plugin
export default {"option":"styles_option__iDAZt","option-selected":"styles_option-selected__NP9LF"};